<script>
import router from "../../router";
import Alert from "@/components/Alert";
export default {
  name: "ViewProduction",
  components: {
    Alert
  },
  data() {
    return {
      order: {
        items: []
      }
    };
  },
  methods: {
    details(id) {
      this.$api
        .getAPI({
          _action: "/production/detail/" + id
        })
        .then(res => {
          this.order = res;
        });
    },
    gettoback() {
      router.push("/production");
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.details(this.$route.params.id);
    }
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-8">
            <div class="card rounded-5 border">
              <div class="card-header bg-white border-bottom px-lg-5 px-4 py-4">
                <div class="row">
                  <div class="col-lg-4 col-md-12 col-12 align-self-center mb-md-0 mb-3">
                    <a href="javascript:void(0)" @click="gettoback()" class="text-primary">
                      <i class="mdi mdi-chevron-left"></i>
                      {{$lang.messages.productions}}
                    </a>
                  </div>
                </div>
              </div>
              <div class="card-body form-style px-lg-5 px-4 py-4">
                <div class="row mb-4">
                  <div class="col-lg-12">
                    <h1
                      class="mb-0"
                    >{{order.production_type == 'PRODUCTION' ? order.pr_number : order.ds_number}}</h1>
                    <p
                      class="text-grey font-14"
                    >{{order.production_type == 'PRODUCTION' ? 'Production' : 'Disassembly'}}</p>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-6">
                    <table>
                      <tr>
                        <td class="pr-3 f-semi-bold">{{$lang.messages.date_created}}:</td>
                        <td>{{order.created_at | moment("MMM DD, YYYY") }}</td>
                      </tr>

                      <tr>
                        <td class="f-semi-bold pr-3">{{$lang.messages.ordered_by}}:</td>
                        <td>{{order.createdBy}}</td>
                      </tr>
                    </table>
                  </div>
                  <div class="col-lg-6">
                    <h4 class="mb-3 f-semi-bold">{{$lang.messages.store}}</h4>
                    <p>{{order.store_name}}</p>
                    <p />
                  </div>
                </div>

                <div class="row mb-4" v-if="order.note">
                  <div class="col-12 mt-4">
                    <p class="f-semi-bold mb-0">{{$lang.messages.notes}}:</p>
                    <p>{{order.note}}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <h3>{{$lang.messages.items}}</h3>
                    <table class="table table-striped table-style-1 table-responsive">
                      <thead>
                        <tr>
                          <th scope="col">{{$lang.messages.item}}</th>
                          <th scope="col">{{$lang.messages.cost}}</th>
                          <th scope="col">{{$lang.messages.quantity}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="obj in order.items" :key="obj.id">
                          <td>
                            {{obj.item_name}}
                            <br />
                            <span
                              class="font-14 text-grey"
                              v-if="obj.sku"
                            >{{$lang.messages.sku}} {{obj.sku}}</span>
                          </td>
                          <td>{{obj.cost ? obj.cost : 0}}</td>
                          <td>{{obj.quantity ? obj.quantity : "-" }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>